import { normalizeModuleDefault } from '@eventbrite/legacy-infra.transformation-utils';
import * as _SIZES_JSON from './iconography_sizes.json';

const SIZES_JSON = normalizeModuleDefault(_SIZES_JSON);

export { SIZES_JSON };
export { AlertChunky } from './icons/AlertChunky';
export { AmexPayment } from './icons/AmexPayment';
export { Apple } from './icons/Apple';
export { ArrowChevronDown } from './icons/ArrowChevronDown';
export { ArrowLeft } from './icons/ArrowLeft';
export { ArrowLeftChunky } from './icons/ArrowLeftChunky';
export { ArrowRight } from './icons/ArrowRight';
export { ArrowRightChunky } from './icons/ArrowRightChunky';
export { Arts } from './icons/Arts';
export { Auto } from './icons/Auto';
export { BancontactPayment } from './icons/BancontactPayment';
export { Beaker } from './icons/Beaker';
export { BlueContentIllustration } from './icons/BlueContentIllustration';
export { BlueContentMobileIllustration } from './icons/BlueContentMobileIllustration';
export { BlueEditIllustration } from './icons/BlueEditIllustration';
export { BlueMoneyIllustration } from './icons/BlueMoneyIllustration';
export { BluePreviewIllustration } from './icons/BluePreviewIllustration';
export { BlueTicketIllustration } from './icons/BlueTicketIllustration';
export { BoltFill } from './icons/BoltFill';
export { Boogie } from './icons/Boogie';
export { Book } from './icons/Book';
export { BrandSuperCropIllustration } from './icons/BrandSuperCropIllustration';
export { Briefcase } from './icons/Briefcase';
export { Bug } from './icons/Bug';
export { BusinessProfession } from './icons/BusinessProfession';
export { Calendar } from './icons/Calendar';
export { CameraGraphic } from './icons/CameraGraphic';
export { Cart } from './icons/Cart';
export { Charity } from './icons/Charity';
export { Check } from './icons/Check';
export { CheckChunky } from './icons/CheckChunky';
export { ChevronDownChunky } from './icons/ChevronDownChunky';
export { ChevronLeftChunky } from './icons/ChevronLeftChunky';
export { ChevronRightChunky } from './icons/ChevronRightChunky';
export { ChevronUpChunky } from './icons/ChevronUpChunky';
export { Clock } from './icons/Clock';
export { ClockChunky } from './icons/ClockChunky';
export { Cocktail } from './icons/Cocktail';
export { CopyChunky } from './icons/CopyChunky';
export { CrossChunky } from './icons/CrossChunky';
export { Crosshair } from './icons/Crosshair';
export { Dating } from './icons/Dating';
export { DiscoBall } from './icons/DiscoBall';
export { DiscoverPayment } from './icons/DiscoverPayment';
export { EyeOnChunky } from './icons/EyeOnChunky';
export { Fashion } from './icons/Fashion';
export { FilmCamera } from './icons/FilmCamera';
export { FilmMedia } from './icons/FilmMedia';
export { FlagChunky } from './icons/FlagChunky';
export { FoodDrink } from './icons/FoodDrink';
export { Game } from './icons/Game';
export { Gear } from './icons/Gear';
export { GearChunky } from './icons/GearChunky';
export { GhostGraphic } from './icons/GhostGraphic';
export { GlobeChunky } from './icons/GlobeChunky';
export { Halloween } from './icons/Halloween';
export { HamburgerMenu } from './icons/HamburgerMenu';
export { Health } from './icons/Health';
export { Heart } from './icons/Heart';
export { HeartChunky } from './icons/HeartChunky';
export { HeartFill } from './icons/HeartFill';
export { HeartFillChunky } from './icons/HeartFillChunky';
export { HelpChunky } from './icons/HelpChunky';
export { Hobbies } from './icons/Hobbies';
export { Holiday } from './icons/Holiday';
export { HolidayCalendar } from './icons/HolidayCalendar';
export { House } from './icons/House';
export { IdCard } from './icons/IdCard';
export { IdealPayment } from './icons/IdealPayment';
export { InfoChunky } from './icons/InfoChunky';
export { InviteGraphic } from './icons/InviteGraphic';
export { KeyboardChunky } from './icons/KeyboardChunky';
export { LinkChunky } from './icons/LinkChunky';
export { LogoEBrand } from './icons/LogoEBrand';
export { LogoFacebook } from './icons/LogoFacebook';
export { LogoGmail } from './icons/LogoGmail';
export { LogoGoogleCalendar } from './icons/LogoGoogleCalendar';
export { LogoGooglePlus } from './icons/LogoGooglePlus';
export { LogoInstagram } from './icons/LogoInstagram';
export { LogoLinkedin } from './icons/LogoLinkedin';
export { LogoMessenger } from './icons/LogoMessenger';
export { LogoPinterest } from './icons/LogoPinterest';
export { LogoTwitter } from './icons/LogoTwitter';
export { LogoWhatsapp } from './icons/LogoWhatsapp';
export { LogoWordmarkBrand } from './icons/LogoWordmarkBrand';
export { MagnifyingGlassChunky } from './icons/MagnifyingGlassChunky';
export { Mail } from './icons/Mail';
export { MailFillChunky } from './icons/MailFillChunky';
export { Map } from './icons/Map';
export { MapPinChunky } from './icons/MapPinChunky';
export { Mask } from './icons/Mask';
export { MastercardPayment } from './icons/MastercardPayment';
export { Megaphone } from './icons/Megaphone';
export { Mic } from './icons/Mic';
export { MlpCharity } from './icons/MlpCharity';
export { MlpCorporate } from './icons/MlpCorporate';
export { MlpFood } from './icons/MlpFood';
export { MlpMusic } from './icons/MlpMusic';
export { MlpNetworking } from './icons/MlpNetworking';
export { MlpPerforming } from './icons/MlpPerforming';
export { MlpRetail } from './icons/MlpRetail';
export { MlpSports } from './icons/MlpSports';
export { MusicNote } from './icons/MusicNote';
export { OrangeFlagIllustration } from './icons/OrangeFlagIllustration';
export { Park } from './icons/Park';
export { PaypalPayment } from './icons/PaypalPayment';
export { PencilChunky } from './icons/PencilChunky';
export { PencilFill } from './icons/PencilFill';
export { PlaceholderSvg1 } from './icons/PlaceholderSvg1';
export { PlaceholderSvg2 } from './icons/PlaceholderSvg2';
export { PlaceholderSvg3 } from './icons/PlaceholderSvg3';
export { PlaceholderSvg4 } from './icons/PlaceholderSvg4';
export { PlusChunky } from './icons/PlusChunky';
export { Religion } from './icons/Religion';
export { RockingHorse } from './icons/RockingHorse';
export { ShareIosChunky } from './icons/ShareIosChunky';
export { Shoe } from './icons/Shoe';
export { Sports } from './icons/Sports';
export { Star } from './icons/Star';
export { StatusDotChunky } from './icons/StatusDotChunky';
export { ThumbsDownChunky } from './icons/ThumbsDownChunky';
export { Ticket } from './icons/Ticket';
export { TicketChunky } from './icons/TicketChunky';
export { Tickets } from './icons/Tickets';
export { TicketsIllustration } from './icons/TicketsIllustration';
export { Travel } from './icons/Travel';
export { Trending } from './icons/Trending';
export { UnorderedList } from './icons/UnorderedList';
export { User } from './icons/User';
export { UserChunky } from './icons/UserChunky';
export { UserFill } from './icons/UserFill';
export { VerticalDotsChunky } from './icons/VerticalDotsChunky';
export { VideoChunky } from './icons/VideoChunky';
export { VisaPayment } from './icons/VisaPayment';
